import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import {
  ConnectedUserEntity,
  ProfilType,
} from '../../../entities/ConnectedUserEntity';
import { ProfilEntity } from '../../../entities/profil.entity';
import { ROUTES } from '../../../routes';

const isAuthenticated = (connectedUser: ConnectedUserEntity) => {
  if (connectedUser) {
    if (
      new Date().getTime() > connectedUser.nextAuthDate ||
      connectedUser.authentifie === false
    ) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
};

const hasAccess = (
  connectedUser: ConnectedUserEntity,
  authorization: ProfilType[],
) => {
  for (let profil of authorization) {
    if (connectedUser.profils.map((pro) => pro.code_profil).includes(profil)) {
      return true;
    }
  }
  return false;
};

export const SecureRoute = ({
  exact,
  path,
  component,
  authorization,
}: {
  exact: boolean;
  path: string;
  component: React.ComponentType;
  authorization?: ProfilType[];
}) => {
  const connectedUser: ConnectedUserEntity = useSelector(
    (state: any) => state.userReducer,
  ).user;

  // si connecté
  if (isAuthenticated(connectedUser)) {
    if (authorization === undefined) {
      // la route n'a pas besoin d'autorisations particulières pour accéder à la page
      return <Route exact={exact} path={path} component={component as any} />;
    } else {
      // si possède les autorisations nécessaires
      if (hasAccess(connectedUser, authorization)) {
        return <Route exact={exact} path={path} component={component as any} />;
      } else {
        return <Redirect to={{ pathname: ROUTES.UNAUTHORIZED }} />;
      }
    }
  } else {
    return <Redirect to={{ pathname: ROUTES.SIGNIN }} />;
  }
};

export const ProtectedView = ({
  children,
  authorization,
}: {
  children: ReactNode;
  authorization?: ProfilType[];
}) => {
  const connectedUser: ConnectedUserEntity = useSelector(
    (state: any) => state.userReducer,
  ).user;

  if (isAuthenticated(connectedUser)) {
    if (authorization === undefined) {
      // la vue n'a pas besoin d'autorisations particulières pour accéder à la page
      return <>{children}</>;
    } else {
      // si possède les autorisations nécessaires
      if (hasAccess(connectedUser, authorization)) {
        return <>{children}</>;
      } else {
        return <></>;
      }
    }
  } else {
    return <></>;
  }
};

export const checkProfile = (
  profils: ProfilEntity[],
  authorization: ProfilType,
) => {
  if (profils.map((pro) => pro.code_profil).includes(authorization)) {
    return true;
  } else {
    return false;
  }
};
